import { type UseQueryResult, useQuery } from 'react-query';
import { StatusDropdownAppServicesService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetAwardMethodTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const awardMethodTypes = useQuery(
    ['getAwardMethodTypes'],
    async () => {
      return await handleRequest(
        StatusDropdownAppServicesService.getApiAwardApiAppStatusDropdownAppServicesAwardMethodTypes()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.value ?? '',
            value: item.text ?? '',
          };
        });
      },
    }
  );

  return awardMethodTypes;
};

export default useGetAwardMethodTypes;
